import { Trophy } from "lucide-react";

function fmt(n) { return n == null ? "0" : n.toLocaleString("pt-BR"); }

export default function BrokerDoletasGoal({ balance, goal, progress }) {
  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 mb-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-white/70">Meta Anual ({fmt(goal)} doletas)</span>
        <span className="text-xs font-bold text-amber-400">{progress}%</span>
      </div>
      <div className="h-3 bg-white/10 rounded-full overflow-hidden">
        <div className="h-full rounded-full bg-gradient-to-r from-amber-500 to-amber-300 transition-all" style={{ width: progress + "%" }} />
      </div>
      <div className="flex justify-between mt-2">
        <span className="text-[10px] text-white/40">{fmt(balance)} / {fmt(goal)}</span>
        {progress >= 100 && (
          <span className="text-[10px] text-amber-300 font-bold flex items-center gap-1"><Trophy className="w-3 h-3" />Meta atingida!</span>
        )}
      </div>
    </div>
  );
}
